import { gradient } from './pattern-gradient';
import { lines } from './pattern-lines';

export const chartPatterns = {
  gradient,
  lines,
};
